import * as _ from 'lodash'

import {
  SHOW_COMPOSER_DIALOG,
  HIDE_COMPOSER_DIALOG,
  ON_CHANGE_BPM_SLIDER,
  ON_CHANGE_SECTION_SLIDER,
  ON_AUDIO_SELECT_CLICK,
  ON_COMPOSER_PLAY_CLICK,
  ON_COMPOSER_PAUSE_CLICK,
  SEND_COMPOSER_REQUEST,
  SEND_COMPOSER_SUCCESS,
  SEND_COMPOSER_FAILURE,
  SHOW_SEND_COMPOSER_DIALOG,
  HIDE_SEND_COMPOSER_DIALOG,
  GET_COMPOSITIONS_REQUEST,
  GET_COMPOSITIONS_SUCCESS,
  GET_COMPOSITIONS_FAILURE,
  SHOW_COMPOSITION_DETAIL,
  SHOW_FORCE_SHARE_COMPOSITION,
  HIDE_FORCE_SHARE_COMPOSITION,
  GET_COMPOSITION_DETAIL_REQUEST,
  GET_COMPOSITION_DETAIL_SUCCESS,
  GET_COMPOSITION_DETAIL_FAILURE,
} from '../../lib/constants'

const initialState = {
  visibleComposerDialog: false,
  visibleSendComposerDialog: false,
  composerPageX: null,
  composerPageY: null,
  composerReadonly: false,
  audioName: '',
  sections: null,
  responseMsg: null,
  sendComposerSuccess: false,
  allCompositions: { data:[], metadata:null },
  fetchingAllCompositions: false,
  compositionUsername: '',
  compositionCreated: '',
  forceShareCompositionTitle: null,
  forceShareCompositionUrl: null,
  forceShareCompositionVisible: false
}
const ComposerReducer = (state = initialState, action) => {

  // console.log(action)
  switch (action.type) {

    case SHOW_COMPOSITION_DETAIL:
      return {
        ...state,
        composerReadonly: true,
        visibleComposerDialog: true,
        composerPageX: action.payload.pageX,
        composerPageY: action.payload.pageY,
        audioName: action.payload.title,
        sections: JSON.parse(action.payload.composition),
        compositionUsername: action.payload.username,
        compositionCreated: action.payload.created,
      }

    case GET_COMPOSITIONS_REQUEST:
      return {
        ...state,
        fetchingAllCompositions: true
      }

    case GET_COMPOSITIONS_SUCCESS:
      return {
        ...state,
        fetchingAllCompositions: false,
        allCompositions: action.payload
      }

    case GET_COMPOSITIONS_FAILURE:
      return {
        ...state,
        fetchingAllCompositions: false
      }      

    case SHOW_SEND_COMPOSER_DIALOG:
      return {
        ...state,
        audioName: action.payload.audioName,
        sections: action.payload.sections,
        visibleSendComposerDialog: true
      }

    case HIDE_SEND_COMPOSER_DIALOG:
      return {
        ...state,
        visibleSendComposerDialog: false,
        visibleComposerDialog: true,
        composerReadonly: false,
        compositionUsername: '',
        compositionCreated: '',
      }

    case SEND_COMPOSER_REQUEST:
      return {
        ...state
      }
    case SEND_COMPOSER_SUCCESS:
      return {
        ...state,
        visibleSendComposerDialog: false,
        sendComposerSuccess: true,
      }
    case SEND_COMPOSER_FAILURE:
      return {
        ...state,
        responseMsg: action.payload.error.toString(),
        sendComposerSuccess: false,
      }

    case SHOW_COMPOSER_DIALOG:
      return {
        ...state,
        sendComposerSuccess: false,
        visibleComposerDialog: true,
        composerReadonly: false,
        composerPageX: action.payload.pageX,
        composerPageY: action.payload.pageY,
        compositionUsername: '',
        compositionCreated: '',
      }

    case HIDE_COMPOSER_DIALOG:
      return {
        ...state,
        visibleComposerDialog: false,
        composerReadonly: false,
        compositionUsername: '',
        compositionCreated: '',
      }

    case SHOW_FORCE_SHARE_COMPOSITION:
      return {
        ...state,
        forceShareCompositionTitle: action.payload.shareTitle,
        forceShareCompositionUrl: action.payload.url,
        forceShareCompositionVisible: true
      }

    case HIDE_FORCE_SHARE_COMPOSITION:
      return {
        ...state,
        forceShareCompositionTitle: null,
        forceShareCompositionUrl: null,
        forceShareCompositionVisible: false
      }

    case GET_COMPOSITION_DETAIL_REQUEST:
      return {
        ...state
      }

    case GET_COMPOSITION_DETAIL_SUCCESS:
      return {
        ...state,
        composerReadonly: true,
        visibleComposerDialog: true,
        composerPageX: 0,
        composerPageY: 0,
        audioName: action.payload.title,
        sections: JSON.parse(action.payload.composition),
        compositionUsername: action.payload.username,
        compositionCreated: action.payload.created,
      }

    case GET_COMPOSITION_DETAIL_FAILURE:
      return {
        ...state
      }

  }

  return state
}
export default ComposerReducer


// WEBPACK FOOTER //
// ./src/state/composer/ComposerReducer.js